import { z } from 'zod';
import { dateSchema, quantitySchema } from '../../validation';

/**
 * A live addon attached to a Subscription. Pricing comes from
 * `SUBSCRIPTION_CONFIG.addons[code]` or `subscription.addonOverrides[code]`.
 */
export const subscriptionAddonSchema = z.object({
  /** addon code (e.g. 'whatsapp', 'api_access') */
  code: z.string(),
  /** 'recurring' = charged each renewal; 'one_time' = charged once on purchase */
  billing: z.enum(['recurring', 'one_time']),
  /** number of seats / units (always >= 1) */
  quantity: quantitySchema,
  /** when the addon was purchased (denormalized for audit) */
  purchasedAt: dateSchema,
  /** when the addon stops billing — set when user removes a recurring addon */
  expiresAt: dateSchema.optional(),
});
export type SubscriptionAddon = z.infer<typeof subscriptionAddonSchema>;
